import React from 'react';

import Select from 'react-select';

import countries from '@/data/countries';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectCountry: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={countries.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={countries}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectCountry;
